(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('HelpdeskService', HelpdeskService)

    /** @ngInject */
    function HelpdeskService(HttpService) {
        const HelpdeskService = {
            getAllByParameters: getAllByParameters,
            getById: getById,
            getAllCategories: getAllCategories,
            getAllStatus: getAllStatus,
            getAllArtRequestThemes: getAllArtRequestThemes,
            getAllArtRequestTypes: getAllArtRequestTypes,
            getAllArtTypes: getAllArtTypes,
            postTicket: postTicket,
            postTimeline: postTimeline,
            postAttachment: postAttachment,
            putTicket: putTicket,
            deleteAttachment: deleteAttachment,
            duplicate: duplicate
        }

        return HelpdeskService;

        function getAllByParameters(params, personId = null) {
            let url = '';

            if (personId)
                url = `/${personId}`;

            return HttpService.get(`/ticket/parameters${url}`, {
                params
            });
        }

        function getById(ticketId, personId) {
            return HttpService.get(`/ticket/${ticketId}/${personId}`);
        }

        function getAllCategories(isPersonAdministrator, personId) {
            let url = '';

            if (isPersonAdministrator != null && personId != null)
                url = `?isPersonAdministrator=${isPersonAdministrator}&personId=${personId}`;

            return HttpService.get(`/ticket-category${url}`);
        }

        function getAllStatus() {
            return HttpService.get('/ticket/status');
        }

        function getAllArtRequestThemes() {
            return HttpService.get('/ticket/art-request-theme');
        }

        function getAllArtRequestTypes() {
            return HttpService.get('/ticket/art-request-type');
        }

        function getAllArtTypes() {
            return HttpService.get('/ticket/art-types');
        }

        function postTicket(ticket) {
            return HttpService.post('/ticket?debug', ticket);
        }

        function postTimeline(timeline, personId) {
            return HttpService.post(`/ticket-timeline?personId=${personId}`, timeline);
        }

        function postAttachment(attachment) {
            return HttpService.post('/ticket-attachment', attachment);
        }

        function putTicket(ticket) {
            return HttpService.put('/ticket', ticket);
        }

        function deleteAttachment(attachmentId, attachmentUrl) {
            return HttpService.delete(`/ticket-attachment/${attachmentId}/${attachmentUrl}`);
        }

        function duplicate(ticketId) {
            return HttpService.post(`/ticket/${ticketId}/duplicate`);
        }
    }
}());